module.exports = __webpack_public_path__ + "img/tournament-details.4b42a7dd.jpg";